import { actionTypes } from "./actions";
import emptyState from "./emptyState";
import { compose } from "redux";
import { immutableSet } from "../../../utils/immutable";
import { ENTITLEMENT_LIST, LOADER_IDENTIFIER } from "./constants";
import { IDENTITY_SYSTEM } from "../../../module/constants";

const ACTION_HANDLERS = {
  [actionTypes.FETCH_USER_ENTITLEMENT_REQUEST]: (
    state: any,
    action: { type: string; payload: any }
  ) => {
    return immutableSet([LOADER_IDENTIFIER], true, state);
  },
  [actionTypes.FETCH_USER_ENTITLEMENT_REQUEST_SUCCESS]: (
    state: any,
    action: { type: string; payload: any }
  ) => {
    const entitlements =
      action.payload.entitlements.length > 0
        ? action.payload.entitlements
            .filter((ent: any) => ent.showOnFrontend !== false)
            .map((data: any) => {
              return {
                identitySystemId:
                  IDENTITY_SYSTEM[
                    data.identity_system_id as keyof typeof IDENTITY_SYSTEM
                  ],
                entitlement_id: data.entitlement_id,
                application_name: data.application_name,
                application_description: data.application_description,
                entitlement_name: data.entitlement_name,
                entitlement_description: data.entitlement_description,
              };
            })
        : [];
    const businessRoles =
      action.payload.businessRoles.length > 0
        ? action.payload.businessRoles.map((data: any) => {
            const brEntitlements =
              data.entitlements && data.entitlements.length > 0
                ? data.entitlements.map((ent: any) => {
                    return {
                      identitySystemId:
                        IDENTITY_SYSTEM[
                          ent.identitySystem as keyof typeof IDENTITY_SYSTEM
                        ],
                      entitlement_id: ent.id,
                      entitlement_name: ent.entitlementName,
                      entitlement_description: ent.entitlementDescription,
                      application_name: ent.applicationName,
                      application_description: ent.applicationDescription,
                    };
                  })
                : [];
            return {
              identitySystemId: "",
              entitlement_id: data.id,
              application_name: data.name,
              application_description: data.description,
              entitlement_name: "",
              entitlement_description: "",
              application_id: "",
              isBR: true,
              entitlements: brEntitlements,
            };
          })
        : [];
    const resultRes = [...entitlements, ...businessRoles];
    return compose(
      immutableSet([ENTITLEMENT_LIST], resultRes),
      immutableSet([LOADER_IDENTIFIER], false)
    )(state);
  },
  [actionTypes.FETCH_USER_ENTITLEMENT_REQUEST_FAILURE]: (
    state: any,
    action: { type: string; payload: any }
  ) => {
    return compose(
      immutableSet([ENTITLEMENT_LIST], []),
      immutableSet([LOADER_IDENTIFIER], false)
    )(state);
  },
};
export default function communicationReducer(state = emptyState, action: any) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    action.payload.location.pathname === "/welcome"
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
